import React, { PureComponent } from "react";
import debounce from "lodash.debounce";
import styles from "./Filter.local.scss";
import _ from "i18n";

export default class FilterComponent extends PureComponent {
  state = {
    activeTab: "ALL"
  };

  handelClick = type => {
    const { fetchMedias, filter, status, setFilter } = this.props;
    if (type === "ALBUM") {
      filter.category = null;
    }
    filter.type = type;
    setFilter(filter);

    const helpFilter = status ? { ...filter, status } : filter;

    if (type !== "ALBUM") {
      fetchMedias({ filterBy: helpFilter, limit: 42 });
    }
  };

  fetchData = filter => {
    const { fetchMedias, status } = this.props;
    const helpFilter = status ? { ...filter, status } : filter;
    fetchMedias({ filterBy: helpFilter, limit: 42 });
  };

  delayQuery = debounce(q => this.fetchData(q), 1000);
  onInputChange = e => {
    const { setFilter } = this.props;
    let filter = this.props.filter;
    filter.search = e.target.value;
    setFilter(filter);
    this.delayQuery(filter);
  };

  render() {
    const { tabs, withSearch, filter } = this.props;

    return (
      <div className={styles.filter}>
        <ul className={styles.tabs}>
          <li
            className={filter.type === "ALL" ? styles.activated : ""}
            onClick={() => this.handelClick("ALL")}
          >
            {_("All")}
          </li>
          {tabs.indexOf("IMAGE") !== -1 ? (
            <li
              className={filter.type === "IMAGE" ? styles.activated : ""}
              onClick={() => this.handelClick("IMAGE")}
            >
              {_("Images")}
            </li>
          ) : null}
          {tabs.indexOf("VIDEO") !== -1 ? (
            <li
              className={filter.type === "VIDEO" ? styles.activated : ""}
              onClick={() => this.handelClick("VIDEO")}
            >
              {_("Videos")}
            </li>
          ) : null}
          {tabs.indexOf("PDF") !== -1 && tabs.indexOf("PPT") !== -1 ? (
            <li
              className={filter.type === "DOC" ? styles.activated : ""}
              onClick={() => this.handelClick("DOC")}
            >
              {_("Documents")}
            </li>
          ) : null}
          {tabs.indexOf("ALBUM") !== -1 ? (
            <li
              className={filter.type === "ALBUM" ? styles.activated : ""}
              onClick={() => this.handelClick("ALBUM")}
            >
              {_("Albums")}
            </li>
          ) : null}
        </ul>
        {withSearch ? (
          <div className={styles.search}>
            <i className="icon-magnifier" />
            <input
              type="text"
              placeholder={_("Search...")}
              value={filter.search}
              onChange={this.onInputChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Filter/FilterComponent.js